import { FlexColumn, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { CompositionPlacement } from "./CompositionPlacement";
import { SalesRegionException } from "./SalesRegionException";

interface BaseCompositionRightDrawerMainTextProps { 
	placement: CompositionPlacement;
	salesRegionException: SalesRegionException;
}

const BaseCompositionRightDrawerMainText: FunctionComponent<BaseCompositionRightDrawerMainTextProps> = observer(function BaseCompositionRightDrawer({ placement, salesRegionException }) {
	const {
		key,
		rightDrawerPlacementText,
		getSortedBaseCompositionMaterials,
	} = placement;

	return (
		<FlexColumn
			data-csi-automation="CompositionPlacementPreview"
			gap={4}
			key={key}
			paddingX={4}
			paddingY={3}
		>
			{salesRegionException.includeCompositionPlacementNames && (
				<Text
					data-csi-automation="CompositionPlacement"
					semiBold
					size={14}
					text={rightDrawerPlacementText}
				/>
			)}
			<FlexColumn gap={2}>
				{getSortedBaseCompositionMaterials(salesRegionException).map(({ key, getRightDrawerMaterialText, nestUnderContainsPlacement }, materialIndex) => (
					(!nestUnderContainsPlacement && (
						<Text
							data-csi-automation="CompositionMaterial"
							key={key}
							size={12}
							text={getRightDrawerMaterialText(salesRegionException)}
						/>
					))
				))}
			</FlexColumn>
		</FlexColumn>
	);
});

export default BaseCompositionRightDrawerMainText;